import { rawAxios as axios } from "./axios";
import { api } from "./axios.config";

// const API_URL = api.manageApiUrl;

const API_URL = api.manageApiUrl;

const GET_EVENTS = "/hosted-events";
const GET_FEATURED_EVENTS = "/past-events";

export function getEvents(limit, search_query, past_events, future_events, running_events) {
	let QUERY = `?limit=${limit}`;
	if (search_query !== "") QUERY += `&search_query=${search_query}`;
	if (past_events !== "") QUERY += `&past_events=${past_events}`;
	if (future_events !== "") QUERY += `&future_events=${future_events}`;
	if (running_events !== "") QUERY += `&running_events=${running_events}`;
	return axios.get(API_URL + GET_EVENTS + QUERY);
}

export function getFeaturedEvents(params = {}) {
	const {
		search = "",
		city = null,
		country = null,
		featured_category = null,
	} = params;

	const queryParams = new URLSearchParams();

	if (search) queryParams.append("search", search);
	if (city) queryParams.append("city", city);
	if (country) queryParams.append("country", country);
	if (featured_category) queryParams.append("featured_category", featured_category);

	const queryString = queryParams.toString();
	const url = `${API_URL}/featured-events${queryString ? `?${encodeURI(queryString)}` : ""}`;

	return axios.get(url);
}

export function getEventFilters(params = {}) {
	const {
		fetch,
		city = null,
		country = null,
	} = params;

	const queryParams = new URLSearchParams();

	if (fetch) queryParams.append("fetch", fetch);
	if (city) queryParams.append("city", city);
	if (country) queryParams.append("country", country);
	const queryString = queryParams.toString();
	console.log(queryString, 'queryString')
	const url = `${API_URL}/featured-events/filters${queryString ? `?${encodeURI(queryString)}` : ""}`;

	return axios.get(url);
}